@let favGame = game();
<a
  (click)="handleNavigate()"
  class="button h-32 rounded-6 button--style-primary"
  [class.s-32]="!favGame.showValue"
  [class.padding-x-6]="favGame.showValue"
  [ngpTooltipTrigger]="gameNameTooltip"
  [ngpTooltipTriggerHideDelay]="0"
  [class.button--style-primary-bordered-2]="isLinkActive()"
  [class.button--style-primary-bordered]="!isLinkActive()"
>
  <svg-icon class="flex items-center justify-center s-24" [src]="favGame.icon"></svg-icon>
  @if(favGame.showValue) {
  <number-flow style="color: currentColor" #valueNumberFlow></number-flow>
  }
</a>
<ng-template #gameNameTooltip>
  <div ngpTooltip class="tooltip typography-tooltip">
    {{ favGame.name }}
  </div>
</ng-template>
